import { useState, useEffect, useRef } from 'react';

const BUSINESS_TYPES = [
  {
    id: 'educacion',
    icon: 'ri-graduation-cap-line',
    label: 'Educación',
    color: '#0D9488',
    title: 'Plataformas Educativas',
    description: 'Sistemas de gestión académica, aulas virtuales, matrículas en línea y portales de estudiantes para colegios, institutos y universidades.',
    features: [
      { icon: 'ri-book-open-line', text: 'Aulas virtuales interactivas' },
      { icon: 'ri-user-star-line', text: 'Gestión de notas y asistencia' },
      { icon: 'ri-calendar-check-line', text: 'Matrículas y pagos en línea' },
      { icon: 'ri-bar-chart-2-line', text: 'Reportes académicos en tiempo real' },
    ],
    image: 'https://public.readdy.ai/ai/img_res/7d01901f618f2e6b975f998538399772.jpg',
  },
  {
    id: 'comercio',
    icon: 'ri-store-2-line',
    label: 'Comercio',
    color: '#F59E0B',
    title: 'Tiendas & E-commerce',
    description: 'Catálogos de productos, carrito de compras, pasarelas de pago y panel de administración de pedidos para cualquier tipo de negocio.',
    features: [
      { icon: 'ri-shopping-cart-line', text: 'Carrito de compras optimizado' },
      { icon: 'ri-bank-card-line', text: 'Pagos seguros integrados' },
      { icon: 'ri-truck-line', text: 'Seguimiento de pedidos' },
      { icon: 'ri-pie-chart-2-line', text: 'Panel de ventas y estadísticas' },
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20ecommerce%20web%20application%20dashboard%20with%20product%20catalog%20shopping%20cart%20order%20management%20and%20sales%20analytics%20charts%20on%20computer%20screen%2C%20clean%20professional%20UI%20design%2C%20amber%20orange%20color%20accents%2C%20minimal%20white%20background%2C%20business%20software%20interface&width=480&height=300&seq=webapp-commerce-v2&orientation=landscape',
  },
  {
    id: 'salud',
    icon: 'ri-heart-pulse-line',
    label: 'Salud',
    color: '#10B981',
    title: 'Sistemas de Salud',
    description: 'Historia clínica digital, agendamiento de citas, gestión de pacientes y reportes médicos para clínicas, consultorios y hospitales.',
    features: [
      { icon: 'ri-file-list-3-line', text: 'Historia clínica electrónica' },
      { icon: 'ri-calendar-2-line', text: 'Citas médicas en línea' },
      { icon: 'ri-capsule-line', text: 'Control de medicamentos' },
      { icon: 'ri-stethoscope-line', text: 'Reportes y diagnósticos' },
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20healthcare%20medical%20web%20application%20dashboard%20showing%20patient%20records%20appointment%20scheduling%20medical%20history%20and%20health%20analytics%20on%20computer%20screen%2C%20clean%20professional%20UI%20design%2C%20green%20emerald%20color%20accents%2C%20minimal%20white%20background%2C%20medical%20software%20interface&width=480&height=300&seq=webapp-salud-v2&orientation=landscape',
  },
  {
    id: 'restaurante',
    icon: 'ri-restaurant-line',
    label: 'Restaurantes',
    color: '#EF4444',
    title: 'Gestión de Restaurantes',
    description: 'Menú digital, reservas de mesas, pedidos online y sistema de delivery integrado para restaurantes, cafés y servicios de catering.',
    features: [
      { icon: 'ri-menu-line', text: 'Menú digital interactivo' },
      { icon: 'ri-table-line', text: 'Reservas de mesas online' },
      { icon: 'ri-motorbike-line', text: 'Sistema de delivery' },
      { icon: 'ri-receipt-line', text: 'Facturación automatizada' },
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20restaurant%20management%20web%20application%20dashboard%20showing%20digital%20menu%20table%20reservations%20order%20tracking%20and%20delivery%20management%20interface%20on%20tablet%20screen%2C%20clean%20professional%20UI%20design%2C%20red%20warm%20color%20accents%2C%20minimal%20white%20background%2C%20food%20service%20software%20interface&width=480&height=300&seq=webapp-restaurante-v2&orientation=landscape',
  },
  {
    id: 'logistica',
    icon: 'ri-truck-line',
    label: 'Logística',
    color: '#8B5CF6',
    title: 'Logística & Inventario',
    description: 'Control de almacenes, gestión de rutas, seguimiento GPS de flotas y reportes de inventario para empresas de distribución y transporte.',
    features: [
      { icon: 'ri-map-pin-line', text: 'Rastreo GPS en tiempo real' },
      { icon: 'ri-archive-line', text: 'Control de inventario' },
      { icon: 'ri-route-line', text: 'Optimización de rutas' },
      { icon: 'ri-file-chart-2-line', text: 'Reportes de operación' },
    ],
    image: 'https://readdy.ai/api/search-image?query=modern%20logistics%20fleet%20management%20web%20application%20dashboard%20showing%20GPS%20tracking%20map%20inventory%20control%20route%20optimization%20and%20delivery%20reports%20interface%20on%20computer%20screen%2C%20clean%20professional%20UI%20design%2C%20purple%20violet%20color%20accents%2C%20minimal%20white%20background%2C%20supply%20chain%20software%20interface&width=480&height=300&seq=webapp-logistica-v2&orientation=landscape',
  },
];

const TECH_STACK = [
  { icon: 'ri-reactjs-line', name: 'React', color: '#0D9488' },
  { icon: 'ri-html5-line', name: 'HTML5', color: '#F59E0B' },
  { icon: 'ri-css3-line', name: 'CSS3', color: '#0D9488' },
  { icon: 'ri-javascript-line', name: 'JavaScript', color: '#F59E0B' },
  { icon: 'ri-database-2-line', name: 'Base de Datos', color: '#0D9488' },
  { icon: 'ri-cloud-line', name: 'Cloud', color: '#F59E0B' },
  { icon: 'ri-smartphone-line', name: 'Responsive', color: '#0D9488' },
  { icon: 'ri-shield-check-line', name: 'Seguridad', color: '#F59E0B' },
];

const PROCESS_STEPS = [
  { number: '01', icon: 'ri-lightbulb-line', title: 'Análisis', desc: 'Escuchamos tus necesidades y definimos el alcance del proyecto.' },
  { number: '02', icon: 'ri-pencil-ruler-2-line', title: 'Diseño', desc: 'Prototipamos la interfaz y la experiencia de usuario.' },
  { number: '03', icon: 'ri-code-s-slash-line', title: 'Desarrollo', desc: 'Construimos tu aplicación con tecnologías modernas.' },
  { number: '04', icon: 'ri-rocket-2-line', title: 'Lanzamiento', desc: 'Desplegamos y te entregamos con soporte incluido.' },
];

function useVisible(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return { ref, isVisible };
}

export default function WebApps() {
  const [activeTab, setActiveTab] = useState('educacion');
  const [hoveredStep, setHoveredStep] = useState<number | null>(null);
  const [hoveredTech, setHoveredTech] = useState<number | null>(null);
  const { ref: sectionRef, isVisible } = useVisible();

  const activeBusiness = BUSINESS_TYPES.find(b => b.id === activeTab)!;

  const scrollToContact = () => {
    const el = document.getElementById('contacto');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="webapps"
      ref={sectionRef}
      className="py-20 md:py-28 relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #F8F9FA 0%, #ffffff 50%, #F0FDF9 100%)' }}
    >
      <style>{`
        @keyframes wa-fade-up {
          from { opacity: 0; transform: translateY(32px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes wa-fade-left {
          from { opacity: 0; transform: translateX(-28px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes wa-fade-right {
          from { opacity: 0; transform: translateX(28px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        @keyframes wa-tab-slide {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes wa-spin-slow {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes wa-pulse-ring {
          0%   { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(2.2); opacity: 0; }
        }
        @keyframes wa-float {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-8px); }
        }
        .wa-float { animation: wa-float 3.5s ease-in-out infinite; }
        .wa-spin  { animation: wa-spin-slow 20s linear infinite; }
      `}</style>

      {/* Decorative blobs */}
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-5 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #0D9488, transparent 70%)' }} />
      <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full opacity-5 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #F59E0B, transparent 70%)' }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ── HEADER ── */}
        <div
          className="text-center mb-14 md:mb-18"
          style={{ opacity: isVisible ? 1 : 0, animation: isVisible ? 'wa-fade-up 0.7s ease forwards' : 'none' }}
        >
          <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-5 py-2 rounded-full mb-4">
            <i className="ri-code-s-slash-line text-[#0D9488] text-sm"></i>
            <span className="text-[#0D9488] font-semibold text-xs md:text-sm">Desarrollo Digital</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#1A1A2E] mb-4 px-4">
            Aplicaciones Web Para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0D9488] to-[#F59E0B]">
              Cualquier Negocio
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4 leading-relaxed">
            Transformamos tus procesos en soluciones digitales a medida, modernas, rápidas y fáciles de usar.
            Desde el diseño hasta el lanzamiento, te acompañamos en cada paso.
          </p>
        </div>

        {/* ── TABS DE SECTORES ── */}
        <div
          className="mb-8"
          style={{ opacity: isVisible ? 1 : 0, animation: isVisible ? 'wa-fade-up 0.7s 0.15s ease forwards' : 'none' }}
        >
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {BUSINESS_TYPES.map((bt) => (
              <button
                key={bt.id}
                onClick={() => setActiveTab(bt.id)}
                className={`flex items-center gap-2 px-4 md:px-5 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border-2 ${
                  activeTab === bt.id
                    ? 'text-white shadow-lg scale-105'
                    : 'bg-white text-gray-500 hover:text-gray-700 hover:scale-105 border-transparent hover:border-gray-200'
                }`}
                style={activeTab === bt.id ? { backgroundColor: bt.color, borderColor: bt.color, boxShadow: `0 6px 20px ${bt.color}40` } : {}}
              >
                <i className={`${bt.icon} text-base`}></i>
                <span>{bt.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* ── PANEL ACTIVO ── */}
        <div
          key={activeTab}
          className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center mb-20"
          style={{ animation: 'wa-tab-slide 0.4s ease forwards' }}
        >
          {/* Info */}
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl" style={{ backgroundColor: `${activeBusiness.color}18` }}>
                <i className={`${activeBusiness.icon} text-3xl`} style={{ color: activeBusiness.color }}></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A2E]">{activeBusiness.title}</h3>
            </div>

            <p className="text-gray-500 leading-relaxed text-base md:text-lg">{activeBusiness.description}</p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {activeBusiness.features.map((feat, i) => (
                <li
                  key={i}
                  className="flex items-center gap-3 bg-white rounded-xl p-3.5 border border-gray-100 hover:border-[#0D9488]/30 hover:-translate-y-0.5 transition-all cursor-default group"
                >
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 transition-all group-hover:scale-110"
                    style={{ backgroundColor: `${activeBusiness.color}15` }}>
                    <i className={`${feat.icon} text-lg`} style={{ color: activeBusiness.color }}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{feat.text}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={scrollToContact}
              className="group inline-flex items-center gap-2 px-6 py-3.5 rounded-full font-bold text-white text-sm hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: activeBusiness.color, boxShadow: `0 8px 24px ${activeBusiness.color}40` }}
            >
              Quiero una app así
              <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          {/* Imagen */}
          <div className="relative wa-float">
            <div className="relative rounded-2xl overflow-hidden border border-gray-100"
              style={{ boxShadow: `0 20px 60px ${activeBusiness.color}20` }}>
              <img
                src={activeBusiness.image}
                alt={activeBusiness.title}
                className="w-full h-64 md:h-72 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />

              {/* badge */}
              <div className="absolute bottom-4 left-4 flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-lg">
                <span className="relative flex h-2 w-2 flex-shrink-0">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" style={{ backgroundColor: activeBusiness.color }}></span>
                  <span className="relative inline-flex rounded-full h-2 w-2" style={{ backgroundColor: activeBusiness.color }}></span>
                </span>
                <span className="text-xs font-bold text-gray-700">En producción</span>
              </div>
            </div>

            {/* deco corner */}
            <div className="absolute -top-3 -right-3 w-14 h-14 rounded-full opacity-20 wa-spin"
              style={{ border: `3px dashed ${activeBusiness.color}` }} />
          </div>
        </div>

        {/* ── PROCESO ── */}
        <div
          className="mb-20"
          style={{ opacity: isVisible ? 1 : 0, animation: isVisible ? 'wa-fade-up 0.7s 0.3s ease forwards' : 'none' }}
        >
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-2">
              ¿Cómo Trabajamos?
            </h3>
            <p className="text-gray-500 text-sm md:text-base">Un proceso claro y transparente de principio a fin</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {PROCESS_STEPS.map((step, i) => (
              <div
                key={i}
                className="relative bg-white rounded-2xl p-5 md:p-6 border border-gray-100 cursor-pointer transition-all duration-300"
                style={hoveredStep === i ? {
                  borderColor: '#0D9488',
                  transform: 'translateY(-6px)',
                  boxShadow: '0 16px 40px rgba(13,148,136,0.12)'
                } : {}}
                onMouseEnter={() => setHoveredStep(i)}
                onMouseLeave={() => setHoveredStep(null)}
              >
                {/* Línea conectora */}
                {i < PROCESS_STEPS.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-full w-full h-px z-10"
                    style={{ background: 'linear-gradient(90deg, #0D948840, transparent)', width: 'calc(100% - 10px)', left: 'calc(100% - 4px)' }} />
                )}

                <div className="flex items-start justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center transition-all duration-300"
                    style={{ backgroundColor: hoveredStep === i ? '#0D9488' : '#0D948815' }}>
                    <i className={`${step.icon} text-xl transition-colors duration-300`}
                      style={{ color: hoveredStep === i ? '#ffffff' : '#0D9488' }}></i>
                  </div>
                  <span className="text-3xl font-black text-gray-100 select-none">{step.number}</span>
                </div>

                <h4 className="font-bold text-[#1A1A2E] mb-1.5 text-base">{step.title}</h4>
                <p className="text-xs md:text-sm text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── TECNOLOGÍAS ── */}
        <div
          style={{ opacity: isVisible ? 1 : 0, animation: isVisible ? 'wa-fade-up 0.7s 0.45s ease forwards' : 'none' }}
        >
          <div className="bg-gradient-to-r from-[#1A1A2E] to-[#0f2a2a] rounded-3xl p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-10">

              {/* Texto izq */}
              <div className="lg:w-2/5 text-center lg:text-left space-y-4">
                <div className="inline-flex items-center gap-2 bg-[#F59E0B]/15 px-4 py-2 rounded-full">
                  <i className="ri-stack-line text-[#F59E0B] text-sm"></i>
                  <span className="text-[#F59E0B] text-xs font-bold uppercase tracking-widest">Stack Tecnológico</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">
                  Herramientas Modernas &amp; Probadas
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  Usamos las mejores tecnologías del mercado para que tu aplicación sea rápida, segura y escalable desde el primer día.
                </p>
                <button
                  onClick={scrollToContact}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-white px-6 py-3 rounded-full font-bold text-sm hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
                  style={{ boxShadow: '0 8px 24px rgba(245,158,11,0.4)' }}
                >
                  Comenzar mi proyecto
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>

              {/* Grid de tecnologías */}
              <div className="lg:w-3/5 grid grid-cols-4 gap-3 md:gap-4 w-full">
                {TECH_STACK.map((tech, i) => (
                  <div
                    key={i}
                    className="group flex flex-col items-center gap-2 bg-white/5 rounded-2xl p-3 md:p-4 border border-white/10 cursor-pointer transition-all duration-300"
                    style={hoveredTech === i ? {
                      backgroundColor: `${tech.color}20`,
                      borderColor: `${tech.color}50`,
                      transform: 'translateY(-4px)'
                    } : {}}
                    onMouseEnter={() => setHoveredTech(i)}
                    onMouseLeave={() => setHoveredTech(null)}
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl transition-all duration-300"
                      style={{ backgroundColor: hoveredTech === i ? `${tech.color}30` : 'rgba(255,255,255,0.07)' }}>
                      <i className={`${tech.icon} text-2xl transition-colors duration-300`}
                        style={{ color: hoveredTech === i ? tech.color : 'rgba(255,255,255,0.5)' }}></i>
                    </div>
                    <span className="text-xs font-semibold text-center transition-colors duration-300"
                      style={{ color: hoveredTech === i ? '#ffffff' : 'rgba(255,255,255,0.4)' }}>
                      {tech.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
